exports.API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8081"
    : "https://formapi.sd.se:8081";
